import { render, staticRenderFns } from "./modalHistorialPrecio.vue?vue&type=template&id=011ec4f3&"
import script from "./modalHistorialPrecio.vue?vue&type=script&lang=js&"
export * from "./modalHistorialPrecio.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports